import React from 'react'

import LoaderContext from 'contexts/LoaderContext'
import Loader from 'components/Loader'

const LoaderProvider = ({ children }) => {
  const [state, setState] = React.useState({
    open: false,
    align: 'center',
    title: '',
    message: '',
  })

  return (
    <LoaderContext.Provider value={{ state, setState }}>
      <Loader {...state} />

      {children}
    </LoaderContext.Provider>
  )
}

export default LoaderProvider
